import { render, staticRenderFns } from "./CameraInfo.vue?vue&type=template&id=5534df9f&scoped=true"
import script from "./CameraInfo.vue?vue&type=script&lang=js"
export * from "./CameraInfo.vue?vue&type=script&lang=js"
import style0 from "./CameraInfo.vue?vue&type=style&index=0&id=5534df9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534df9f",
  null
  
)

export default component.exports